import Cookies from "js-cookie";
import { configureAuth } from "react-query-auth";
import { AUTHENTICATED_USER_QUERY_KEY } from "~common/constants";
import { EmojisushiAgent } from "~lib/emojisushi-js-sdk";

export const { useUser, useLogin, useRegister, useLogout, AuthLoader } =
  configureAuth({
    userKey: AUTHENTICATED_USER_QUERY_KEY,
    userFn: () =>
      EmojisushiAgent.fetchUser()
        .then((res) => res.data)
        .catch((e) => {
          // // 406 simply means that user is not authorzied, no need to throw error in this case
          if (![406].includes(e?.response.status)) {
            throw e;
          }
          return null;
        }),
    loginFn: async ({ phone, code }) => {
      const res = await EmojisushiAgent.loginWithSms({
        phone,
        code,
      });
      const { token } = res.data.data;
      Cookies.set("jwt", token);
      return res.data.data.user;
    },
    registerFn: async ({
      phone,
      code,
      password,
      password_confirmation,
      agree,
    }) => {
      const res = await EmojisushiAgent.registerWithPhone({
        phone,
        code,
        password,
        password_confirmation,
        activate: true,
        auto_login: true,
        agree: true,
      });
      const { token } = res.data.data;
      Cookies.set("jwt", token);
      return res.data.data.user;
    },
    logoutFn: async () => {
      Cookies.remove("jwt");

      return true;
    },
  });
